import { render, staticRenderFns } from "./PayqrCode.vue?vue&type=template&id=2c02e163&scoped=true&"
import script from "./PayqrCode.vue?vue&type=script&lang=js&"
export * from "./PayqrCode.vue?vue&type=script&lang=js&"
import style0 from "./PayqrCode.vue?vue&type=style&index=0&id=2c02e163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02e163",
  null
  
)

export default component.exports